












































































































// TODO: Enable lint.
/* eslint-disable */
import { computed, defineComponent, reactive, SetupContext } from '@vue/composition-api';

import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import moment from 'moment';


import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

type Concept = {
	id: string,
	project_id: string,
	cp_template_id: string,
	name?: string,
	title?: string,
	description?: string,
  image_vertical_size?: number,
	topbox?: number,
	sum_of_top2box?: number,
	created_at: string,
	updated_at: string,

  concept_image_id: string,
  cpcard_image_id: string,

  project_name: string 
};

type Project = {
  id: string,	
	organization_id: string,
	user_id: string,       
	name: string,         
	supplemental_memo: string,
	internal_memo: string,
  default_cp_template_id: string,
	is_archived: boolean,
	created_at: string,
	updated_at: string,

  concepts: Concept[]
};


type Props = {
  id: string;
};

export default defineComponent({
  name: "ArchiveEditor",
  components: {
    NavHeader,
    Footer
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  head: {
    link: [
      { rel: 'stylesheet', type: 'text/css', href: '/css/login/project.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/toggle_contents.js" }
    ]
  },

  setup(props: Props, context: SetupContext) {
    const state = reactive({
      project: {} as Project,
    });

    async function load() {
      console.log(props)
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.get('dev', '/projects/' + props.id, options).then(response => {
        console.log(response);
        state.project = response.data;
        console.log(state);
      }).catch(err => {
        console.log(err);
      });
    }
    load();

    async function deleteProject() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.del('dev', '/projects/' + props.id, options).then(response => {
        console.log(response);
        context.root.$router.push('/project');
      }).catch(err => {
        console.log(err);
      });
    }

    async function archiveProject() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.put('dev', '/projects/archives/' + props.id, options).then(response => {
        console.log(response);
        alert("TODO: move to archive mode");
      }).catch(err => {
        console.log(err);
      });
    }

    async function copyProject() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.post('dev', '/projects/copy/' + props.id, options).then(response => {
        console.log(response);
        context.root.$router.push({ name: 'ProjectEditor', params: { id: response.data.id } });
      }).catch(err => {
        console.log(err);
      });
    }

    async function updateProjectWithConcepts() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        body: state.project
      };

      console.log(state.project);

      API.put('dev', '/projects/concepts', options).then(response => {
        console.log(response);
        //context.root.$router.push({ name: 'ProjectEditor', params: { id: response.data.id } });
      }).catch(err => {
        console.log(err);
      });
    }


    return {
      state,
      copyProject,
      updateProjectWithConcepts,
    };
  }
});
